import { useQuery } from "@tanstack/react-query";

import {
  getReportSnapshots,
  PaginationMeta,
  ReportSnapshot,
} from "@services/reportEngine";

export const useReportSnapshots = (params: Record<string, any>) => {
  return useQuery<{ reportSnapshots: ReportSnapshot[]; meta: PaginationMeta }>(
    ["reportSnapshots", params],
    () => getReportSnapshots(params),
    { keepPreviousData: true, refetchOnWindowFocus: false },
  );
};
